var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUncheckedCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_74269_26429",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 1.66699C5.39996 1.66699 1.66663 5.40033 1.66663 10.0003C1.66663 14.6003 5.39996 18.3337 9.99996 18.3337C14.6 18.3337 18.3333 14.6003 18.3333 10.0003C18.3333 5.40033 14.6 1.66699 9.99996 1.66699Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 1.66699C5.39996 1.66699 1.66663 5.40033 1.66663 10.0003C1.66663 14.6003 5.39996 18.3337 9.99996 18.3337C14.6 18.3337 18.3333 14.6003 18.3333 10.0003C18.3333 5.40033 14.6 1.66699 9.99996 1.66699Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 0.666992C4.84767 0.666992 0.666626 4.84804 0.666626 10.0003H2.66663C2.66663 5.95261 5.95224 2.66699 9.99996 2.66699V0.666992ZM0.666626 10.0003C0.666626 15.1526 4.84767 19.3337 9.99996 19.3337V17.3337C5.95224 17.3337 2.66663 14.048 2.66663 10.0003H0.666626ZM9.99996 19.3337C15.1522 19.3337 19.3333 15.1526 19.3333 10.0003H17.3333C17.3333 14.048 14.0477 17.3337 9.99996 17.3337V19.3337ZM19.3333 10.0003C19.3333 4.84804 15.1522 0.666992 9.99996 0.666992V2.66699C14.0477 2.66699 17.3333 5.95261 17.3333 10.0003H19.3333Z",
    fill: "#52B3A7",
    mask: "url(#path-1-inside-1_74269_26429)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheckedCircle);
export default __webpack_public_path__ + "static/media/unchecked-circle.764474e334ed978333314e610c1fa198.svg";
export { ForwardRef as ReactComponent };